import { paths } from '../../config';
import MainContainer from '../main-container';
import Form from './roleForm';
import List from './roleList';

const settings = {
    pathRegister: paths.roleRegister,
    pathList: paths.role,
    apiPath: 'role',
    permissionAdmin: null,
    title: 'Papéis',
};
const Role: React.FC = () => {
    return (
        <MainContainer>
            <Form />
        </MainContainer>
    );
};

const RoleList: React.FC = () => {
    return (
        <MainContainer>
            <List settings={settings} />
        </MainContainer>
    );
};

export { Role, RoleList };
